import { Link, useNavigate } from 'react-router';

import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { SxProps, Theme } from '@mui/material/styles';
import SvgIcon from '@mui/material/SvgIcon';
import Typography from '@mui/material/Typography';

import { PageContextProps, useApp } from '../../contextProviders/AppProvider';
import { useAuth } from '../../contextProviders/AuthProvider';
import { useData } from '../../contextProviders/DataProvider';

interface GratiNavListProps {
  sx?: SxProps<Theme>;
  isDebug?: boolean;
  resetReactRoutes?: boolean;
}

export default function GratiNavList(props: GratiNavListProps) {
  const { sx, isDebug = false, resetReactRoutes = false } = props;
  const { pageContexts } = useApp();
  const { isGod } = useAuth();
  const { getAdminOrgs, getMemberOrgs, getAllActiveOrgs, userState } = useData();
  const navigate = useNavigate();

  const showItem = (page: PageContextProps) => {
    if (!userState.userProfile) {
      return null;
    }

    const isLoggedIn = (isDebug && isGod) || userState.status === 'ready';

    if (page.showLogin && isLoggedIn) {
      if (
        (page.showMembers && getMemberOrgs().length > 0) ||
        (page.showAdminPro && getAdminOrgs().length > 0) ||
        (page.showGod && !isDebug && isGod)
      ) {
        if (page.showIfOneOrg || getAllActiveOrgs().length > 1) {
          return true;
        }
      }
    }
    if (page.showLogout && !isLoggedIn && !isDebug) {
      return true;
    }

    return false;
  };

  return (
    <List sx={{ ...(Array.isArray(sx) ? sx : [sx]), width: '100%', pt: 0, display: 'block' }}>
      {pageContexts.map((page) =>
        showItem(page) ? (
          <ListItem key={page.name} alignItems="center" disablePadding sx={{ width: '100%' }}>
            {resetReactRoutes ? (
              <IconButton
                key={page.name}
                onClick={() => navigate(page.to, { replace: true, state: { fromNavRail: true } })}
              >
                {page.icon ? <SvgIcon component={page.icon} /> : null}
                <Typography variant="iconbutton" sx={{
                  textAlign: "center"
                }}>
                  {page.name}
                </Typography>
              </IconButton>
            ) : (
              <IconButton key={page.name} component={Link} to={page.to}>
                {page.icon ? <SvgIcon component={page.icon} /> : null}
                <Typography variant="iconbutton" sx={{
                  textAlign: "center"
                }}>
                  {page.name}
                </Typography>
              </IconButton>
            )}
          </ListItem>
        ) : null
      )}
    </List>
  );
}
